import { useEffect, useState } from "react";
import { msUntilNextNoon } from "../utils/countdown";

/** Cuenta regresiva que se reinicia todos los días a las 12:00 */
export function useCountdown() {
  const [remaining, setRemaining] = useState(() => msUntilNextNoon());
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(msUntilNextNoon()), 1000);
    return () => window.clearInterval(id);
  }, []);
  return remaining;
}
